import { useState, useEffect } from 'react';
import Login from './Login';
import TrackingTab from './TrackingTab';
import StockTab from './StockTab';
import FormulaTab from './FormulaTab';
import AdminTab from './AdminTab';
import api from './api';

const NAV = [
  { key: 'tracking', label: '生产追踪', roles: ['admin', 'sales', 'procurement', 'warehouse', 'factory'] },
  { key: 'stock', label: '预混料库存', roles: ['admin', 'sales', 'procurement', 'warehouse', 'factory'] },
  { key: 'formula', label: '配方管理', roles: ['admin', 'procurement'] },
  { key: 'admin', label: '用户管理', roles: ['admin'] },
];

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [tab, setTab] = useState('tracking');
  const [formulas, setFormulas] = useState([]);
  const [premixes, setPremixes] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  const loadShared = async () => {
    const [fRes, pRes] = await Promise.all([api.get('/formulas'), api.get('/premixes')]);
    setFormulas(fRes.data);
    setPremixes(pRes.data);
  };

  useEffect(() => { if (user) loadShared(); }, [user]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (!user) return <Login onLogin={u => { setUser(u); }} />;

  const allowedNav = NAV.filter(n => n.roles.includes(user.role));

  return (
    <div style={s.root}>
      {/* Header */}
      <header style={s.header}>
        <div style={s.headerInner}>
          <div style={s.logo}>
            <span style={s.logoIcon}>⬡</span>
            <span style={s.logoText}>预混料管理</span>
          </div>

          {/* Desktop nav */}
          <nav style={s.desktopNav}>
            {allowedNav.map(n => (
              <button key={n.key} style={{ ...s.navBtn, ...(tab === n.key ? s.navBtnActive : {}) }}
                onClick={() => setTab(n.key)}>{n.label}</button>
            ))}
          </nav>

          <div style={s.headerRight}>
            <div style={s.userInfo}>
              <span style={s.userName}>{user.name}</span>
              <span style={s.userRole}>{getRoleLabel(user.role)}</span>
            </div>
            <button style={s.logoutBtn} onClick={handleLogout}>退出</button>
            {/* Mobile menu toggle */}
            <button style={s.menuBtn} onClick={() => setMenuOpen(o => !o)}>☰</button>
          </div>
        </div>

        {/* Mobile nav dropdown */}
        {menuOpen && (
          <div style={s.mobileNav}>
            {allowedNav.map(n => (
              <button key={n.key} style={{ ...s.mobileNavBtn, ...(tab === n.key ? s.mobileNavBtnActive : {}) }}
                onClick={() => { setTab(n.key); setMenuOpen(false); }}>{n.label}</button>
            ))}
          </div>
        )}
      </header>

      <main style={s.main}>
        {tab === 'tracking' && <TrackingTab user={user} formulas={formulas} premixes={premixes} />}
        {tab === 'stock' && <StockTab user={user} premixes={premixes} />}
        {tab === 'formula' && <FormulaTab user={user} formulas={formulas} premixes={premixes} onRefresh={loadShared} />}
        {tab === 'admin' && user.role === 'admin' && <AdminTab />}
      </main>
    </div>
  );
}

function getRoleLabel(role) {
  return { admin: '管理员', sales: '销售部', procurement: '牛场采购', warehouse: '牛场库管', factory: '代工厂' }[role] || role;
}

const s = {
  root: { minHeight: '100vh', background: '#0a0f1e', color: '#e2e8f0', fontFamily: "'DM Mono', 'Courier New', monospace" },
  header: { background: '#0d1529', borderBottom: '1px solid #1e2d4a', position: 'sticky', top: 0, zIndex: 100 },
  headerInner: { maxWidth: 1280, margin: '0 auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 56, gap: 12 },
  logo: { display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 },
  logoIcon: { fontSize: 20, color: '#38bdf8' },
  logoText: { fontSize: 14, fontWeight: 700, letterSpacing: '0.05em', color: '#f1f5f9' },
  desktopNav: { display: 'flex', gap: 2, flex: 1, justifyContent: 'center' },
  navBtn: { background: 'transparent', border: 'none', color: '#64748b', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', transition: 'all 0.15s', whiteSpace: 'nowrap' },
  navBtnActive: { background: '#1e3a5f', color: '#38bdf8', fontWeight: 600 },
  headerRight: { display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 },
  userInfo: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end' },
  userName: { fontSize: 13, color: '#cbd5e1', fontWeight: 600 },
  userRole: { fontSize: 10, color: '#475569' },
  logoutBtn: { background: 'transparent', border: '1px solid #2d3f5f', color: '#64748b', padding: '4px 10px', borderRadius: 5, cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' },
  menuBtn: { display: 'none', background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', padding: '4px 6px' },
  mobileNav: { background: '#0a1628', borderTop: '1px solid #1e2d4a', padding: 12, display: 'flex', flexDirection: 'column', gap: 4 },
  mobileNavBtn: { background: 'transparent', border: 'none', color: '#64748b', padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit', textAlign: 'left' },
  mobileNavBtnActive: { background: '#1e3a5f', color: '#38bdf8', fontWeight: 600 },
  main: { maxWidth: 1280, margin: '0 auto', padding: '28px 20px' },
};
